<template>
  <!-- MODALE DOWNLOAD TRACCIATO WELFAREBRIDGE DI FINE MESE -->
  <b-modal
      ref="wfbridge_modal"
      title="Transazioni mensili per cedolino paghe."
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      @show="resetta_modale"
      v-model="open_close_modal">

      <p class="text-justify">
        Selezionare i due estremi di estrazione e premere il pulsante <i>"Esegui"</i>.
        <b>L'export potrebbe richiedere alcuni secondi per essere completato</b>
      </p>

      <!-- Non segniamo le due date come "required" perchè tale property non     -->
      <!-- venendo l'azione dal form non avrebbe effetto. Controlliamo tutto     -->
      <!-- via codice.                                                           -->
      <form>
      <!-- Data inizio estrazione -->
      <b-form-group
          label="* Data inizio estrazione:"
          :invalid-feedback="date_start_fb_text"
          :state="date_start_validator"
      >
          <b-form-datepicker
          placeholder="Scegli una data"
          v-model="date_start"
          :min="min_date_start"
          :max="max_date_start"
          :state="date_start_validator"
          :disabled="disable_on_download"
          @input="valida_date_di_inizio_e_fine">
          </b-form-datepicker>
      </b-form-group>
      <!-- Data fine estrazione -->
      <b-form-group
          label="* Data fine estrazione:"
          :invalid-feedback="date_end_fb_text"
          :state="date_end_validator"
      >
          <b-form-datepicker
          placeholder="Scegli una data"
          v-model="date_end"
          :min="min_date_end"
          :max="max_date_end"
          :state="date_end_validator"
          :disabled="disable_on_download"
          @input="valida_date_di_inizio_e_fine">
          </b-form-datepicker>
      </b-form-group>
      </form>


      <!-- Rimpiazziamo il footer standard con dei bottoni personalizzati.       -->
      <!-- In particolare il il pulsante di OK modifica la sua forma durante il  -->
      <!-- download, informando l'utente che quest'ultimo è in corso.            -->
      <template #modal-footer>
        <b-button variant="primary" @click="esegui_export" :disabled="disable_on_download">
            <span v-if="!disable_on_download">Esegui</span>
            <span v-else><b-spinner small class="mr-1" :variant="'light'"></b-spinner> Download in corso</span>
        </b-button>
        <b-button @click="open_close_modal=false" :disabled="disable_on_download">Annulla</b-button>
      </template>
  </b-modal>
</template>

<script>
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import moment from 'moment'
import axios from 'axios'
import fileDownload from 'js-file-download'

export default {
  name: 'WfBridgeDownloadModal',
  data () {

    // Calcoliamo la minima e la massima data di estrapolazione
    // per i datepickers Welfarebridge. La minima sarà l'inizio
    // del mese precedente a questo, la massima la data odierna.
    const mese_prima = moment().subtract( 1, 'month').date(1).toDate();
    const oggi = new Date();

    return {
        // Flag disattivazione elementi finestra durante lo scaricamento
        disable_on_download : false,

        // Data inizio estrazione
        date_start : null,
        // Validatore data inizio
        date_start_validator : null,
        // Testo feedback negativo data start
        date_start_fb_text : '',
        // Minima data inizio selezionabile
        min_date_start : mese_prima,
        // Massima data di inizio selezionabile
        max_date_start : oggi,

        // Data fine estrazione
        date_end : null,
        // Validatore data fine
        date_end_validator : null,
        // Testo feedback negativo data end
        date_end_fb_text : '',
        // Minima data fine selezionabile
        min_date_end : mese_prima,
        // Massima data di fine selezionabile
        max_date_end : oggi
    }
  },
  methods: {
    /**
     * Richiama al vista Django che a sua volta richiama il modulo
     * liwe delle apghe per eseguire l'estrazione welfarebridge.
     * I dati scaricati sono sia quelli delle transazioni in stato 6
     * che storicizzate.
     * Per scaricare file con axios abbiamo usato la libreria js-file-download prendendo spunto
     * da: https://stackoverflow.com/questions/41938718/how-to-download-files-using-axios
     */
    esegui_export : function (){

      // Verifico la correttezza delle due date, se non ci siamo non vado oltre.
      this.valida_date_di_inizio_e_fine();

      if ( this.date_start_validator === false || this.date_end_validator === false ) return;

      // Disabilito gli elementi della finestra duarnte il donwload.
      this.disable_on_download = true;

      // Settiamo le due date di inizio e fine e diciamo ad axios di aspettarsi una
      // risposta di tipo blob ritornando il server un file
      let call_params = { params : { date_start : this.date_start,
                                     date_end : this.date_end },
                          responseType: 'blob' }

      axios.get( apiUrl.welfareapi.export_welfarebridge_fine_mese, call_params )
      .then( ( response ) => {
        // Prendiamo il nome dall'header content-disposition
        let nome_file = generalLib.get_nome_file( response );
        // Usiamo js-file-donwload per salvare il file sul client
        fileDownload( response.data, nome_file );
        // Riabilitiamo gli elementi della finestra e chiudiamo la modale
        this.open_close_modal = false;
        this.disable_on_download = false;
      })
      .catch( (error) => {
        this.disable_on_download = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });
    },
    /**
     * All'on show della modale resettiamo tutti gli elementi interni del form
     * per farlo trovare pronto ad una nuova selezione.
     */
    resetta_modale : function () {
      this.date_start = null;
      this.date_start_validator = null;
      this.date_start_fb_text = '';
      this.date_end = null;
      this.date_end_validator = null;
      this.date_end_fb_text = '';
    },
    /**
     * Verifica la presenza e la coerenza delle date di inizio e fine export
     */
    valida_date_di_inizio_e_fine : function() {
      // Data di inizio export
      if ( this.date_start === null ) {
        this.date_start_validator = false
        this.date_start_fb_text = "Inserire una data di inizio export";
      } else if ( this.date_start !== null &&
                  this.date_end !== null &&
                  moment(this.date_start).isAfter(this.date_end) ) {
        this.date_start_validator = false;
        this.date_start_fb_text = "La data di inizio non può essere posta dopo la data di fine.";
      } else {
        this.date_start_validator = true;
        this.date_start_fb_text = "";
      }

      // Data di fine export
      if ( this.date_end === null ) {
        this.date_end_validator = false
        this.date_end_fb_text = "Inserire una data di fine export";
      } else if ( this.date_start !== null &&
                  this.date_end !== null &&
                  moment(this.date_end).isBefore(this.date_start) ) {
        this.date_end_validator = false;
        this.date_end_fb_text = "La data di fine non può essere posta prima della data di inizio.";
      } else {
        this.date_end_validator = true;
        this.date_end_fb_text = "";
      }
    }
  },
  computed : {
    /* Questa computed può essere anche settata ed è di supporto al v-model, viene
       agganciata al v-model della b-modal per aprirla e chiuderla.
       Quando il valore della prop viene settato ( a true ad esempio perchè vogliamo
       aprire la modale ), viene eseguito il metodo get che restituisce il valore
       stesso della property ( true ) ed apre la modale.
       Al click sul pulsante "chiudi" la computed viene settata a false ( voglio chiudere
       la modale ), questo fa si che sia eseguito il set il quale emette l'evento close
       e torna il valore false.
       Avendo definito in "model" l'evento close come evento di update del v-model,
       registrato l'evento, il suo valore (false) viene settato nella property dal chiamante
       e la finestra si chiude! In questo modo la propery non viene mutata direttamente da
       dal componente stesso. */
    open_close_modal : {
      get() {
        return this.show_modal;
      },
      set(value) {
        this.$emit( 'close', value );
      }
    }
  },
  /* Definendo model possiamo agganciare al componente un suo v-model,
     il quale, pilotato dal componente parent può aprire o chiudere la finestra.
     Il valore del v-model sarà sempre passato alla prop show_modal, allo scattare
     dell'evento close il v-model sarà updatato.
     In questo modo si evita la modifica da dentro il componente della
     prop che è un antipattern e viene segnalato come errore. */
  model : {
    prop: 'show_modal',
    event: 'close'
  },
  props : {
    /**
     * Booleano che indica se visualizzare o meno la modale.
     */
    show_modal : {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
</style>